

import DaisoImage from '~/components/common/DaisoImage.vue'

export default {
  name: 'ButtonEl',
  components: {
    DaisoImage
  },
  props: {
    tags: {
      type: String,
      default: 'button'
    },
    iconname: {
      type: String,
      default: ''
    },
    disabled: {
      type: String,
      default: ''
    },
    icontext: {
      type: String,
      default: ''
    },
    iconpos: {
      type: String,
      default: ''
    },
    badgeData: {
      type: String,
      default: ''
    },
    imgName: {
      type: String,
      default: null
    },
    hoverImgName: {
      type: String,
      default: null
    },
    tooltipPopperClass: {
      type: String,
      default: ''
    },
  }
}
